import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { VerificationProcess } from "../../../Component/Model/Dto/VerificationAgency/VerificationProcessTracker";
import { TableColumn } from "../../../Component/Model/Table/Table";
import { DateFormatter, removeHtmlformat } from "../../../Component/Model/helpers";

interface VAProcessTrackerTableRow {
    verificationProcessType: string,
    scheduledDate?: String,
    verificationStatus?: string,
    statusDate?: String,
    note?: String
}

export interface IVAProcessTrackerTable {
    columns: Array<TableColumn>;
    rows: Array<VAProcessTrackerTableRow>;
}

export function VAProcessTrackerTableMapper(results: VerificationProcess.VerificationProcessSearchResponse[], editProcess: (id: number) => void, uploadDocuments: (id: number) => void, sendUsersEmail: (recordId: number) => void, deleteProcess: (id: number) => void): IVAProcessTrackerTable {
    const columns = [
        { Header: 'Verification Process Type', accessor: 'verificationProcessType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Schedule Date', accessor: 'scheduledDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Verification Status', accessor: 'verificationStatus', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Status Date', accessor: 'statusDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Note', accessor: 'note', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (results.length >= 0) {
        const rows: VAProcessTrackerTableRow[] = results.map((item: VerificationProcess.VerificationProcessSearchResponse, index: number) => (
            {
                id: item.id,
                verificationProcessType: item.verificationProcessType,
                scheduledDate: item.scheduledDate ? DateFormatter(item.scheduledDate.toString()) : '',
                verificationStatus: item.verificationStatus,
                statusDate: item.statusDate ? DateFormatter(item.statusDate.toString()) : '',
                note: item.note ? (item.note.length > 45 ? removeHtmlformat(item.note).substring(0, 45) + '...' : removeHtmlformat(item.note)) : '',
                actions: [
                    {
                        key: index.toString(),
                        label: 'Edit',
                        action: () => {
                            editProcess(item.id);
                        },
                        icon: {
                            color: 'info',
                            name: 'edit'
                        }
                    },
                    {
                        key: index.toString(),
                        label: 'Upload documents',
                        action: () => {
                            uploadDocuments(item.id);
                        },
                        icon: {
                            color: 'primary',
                            name: 'attach_file'
                        },
                        showBadge: true,
                        badgeCount: item.documentCount,
                    },
                    {
                        key: index.toString(),
                        label: 'Send Verification Process',
                        action: () => {
                            sendUsersEmail(item.id);
                        },
                        icon: {
                            color: 'grey',
                            name: 'send'
                        }
                    },
                    {
                        key: index.toString(),
                        label: 'Delete',
                        action: () => {
                            deleteProcess(item.id);
                        },
                        icon: {
                            color: 'error',
                            name: 'delete'
                        }
                    },
                ]
            }));
        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}

